import { render, staticRenderFns } from "./ProductCategories.vue?vue&type=template&id=1672dacd&scoped=true&"
import script from "./ProductCategories.vue?vue&type=script&lang=js&"
export * from "./ProductCategories.vue?vue&type=script&lang=js&"
import style0 from "./ProductCategories.vue?vue&type=style&index=0&id=1672dacd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1672dacd",
  null
  
)

export default component.exports